import { render } from "./self-medication.vue?vue&type=template&id=518cd9d6&scoped=true"
const script = {}

import "./self-medication.vue?vue&type=style&index=0&id=518cd9d6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518cd9d6"]])

export default __exports__